import React, { useMemo, useState } from "react";
import { StyleSheet, View } from 'react-native'
import Text from "theme/Text";
import _ from "lodash";
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperString from 'utils/helper-string'
import isEqual from 'react-fast-compare'
import HStack from 'components/atoms/stack/HStack'
import { layoutStyles } from "styles/layout";
import { useIsSmallDevice } from 'utils/helper-device'

const DataItem = ( { identifier = null, title = null, icon = null, content = null, items = null, titleStyle = null, textStyle = null, testID = null, truncateContent = false, truncateContentAction = false, style = {}, children }  ) => {
	
	const maxContentLength = 140;
	const isSmallDevice = useIsSmallDevice();
	
	const [ truncateVisible, setTruncateVisible ] = useState( false )
	
	const contentViewStyle = [
		DataItemStyles.text,
		textStyle
	]
	
	const titleViewTextStyle = [
		DataItemStyles.headerText,
		titleStyle
	]
	
	const titleHeaderTextStyle = [
		DataItemStyles.headerText,
		titleStyle
	]
	
	const contentView = useMemo( () => {
		if( ( _.isObject( content ) || _.isArray( content ) ) && _.isEmpty( content ) ) {
			content = null
		}
		
		if( content === null ) {
			return null;
		}
		
		let result = content;
		switch( true ) {
			case _.isArray( result ):
				result = (
					<HStack
						style={staticStyles.hStackAlignItemsCenter}
						itemStyle={{
							...layoutStyles.flexUnset,
							alignItems: 'center',
						}}>
						
						{ result }
					</HStack>
				)
				break;
				
			default:
				// Check if we need to truncate
				if( truncateContent && !truncateVisible ) {
					if( _.size( result ) > maxContentLength ) {
						result = `${result.substr( 0, maxContentLength )}...`;
					}
				}
				
				result = (
					<Text
						style={ contentViewStyle }
						testID={ `${testID}_content`}>
						
						{ result }
					</Text>
				)
				
				if( truncateContentAction ) {
					result = (
						<ThemedPressable
							onPress={ setTruncateVisible.bind( this, !truncateVisible) }>
							
							{ result }
						</ThemedPressable>
					)
				}
		}
		
		return result;
	}, [ content, truncateContent, truncateVisible ]);
	
	let itemsView = null;
	if( items !== null ) {
		itemsView = (
			<View
				key={ HelperString.hash('data-item-items', identifier ) }
				style={ DataItemStyles.itemContainer }>
				
				{ items }
			</View>
		)
	}
	
	const titleText = title === null && !_.isEmpty( children ) ? children : title;
	
	let titleView = null;
	switch( true ) {
		case !_.isEmpty( icon ) && !_.isEmpty( titleText ):
			titleView = (
				<View
					key={ HelperString.hash('data-item-header', identifier ) }
					style={ DataItemStyles.headerContainer }>
					
					<View
						style={ DataItemStyles.headerIconContainer}>
						
						{ icon }
					</View>
					<View
						style={ DataItemStyles.headerTextContainer}>
						
						<Text
							style={ titleViewTextStyle }
							testID={ `${testID}_title` }>
							
							{ titleText }
						</Text>
					</View>
				</View>
			)
			break;
			
		case _.isEmpty( icon ) && !_.isEmpty( titleText ):
			titleView = (
				<Text
					key={ HelperString.hash('data-item-title', identifier ) }
					style={titleHeaderTextStyle }>
					
					{ titleText }
				</Text>
			)
			break;
	}
	
	return (
		<View
			style={ [ DataItemStyles.container, isSmallDevice ? DataItemStyles.containerSmall : null, style ] }
			key={ HelperString.hash('data-item-container', identifier ) }>
			
			{ titleView }
			
			{ contentView }
			
			{ itemsView }
		</View>
	);
}

const staticStyles = StyleSheet.create({
	hStackAlignItemsCenter: {
		alignItems: 'center',
	},
});

export default React.memo( DataItem, isEqual );
